import {Component, OnInit, EventEmitter, Output, Input} from '@angular/core';
import {ImunizacaoService} from '../../services/imunizacao.service';
import {NgxSpinnerService} from 'ngx-spinner';
import * as moment from 'moment';

@Component({
  selector: 'app-modal-arquivos-logs',
  templateUrl: './modal-arquivos-logs.component.html',
  styleUrls: ['./modal-arquivos-logs.component.scss'],
})
export class ModalArquivosLogsComponent implements OnInit {
  @Input() filesLogs: any;
  @Output() fecharModal = new EventEmitter();

  currentPage = 1;
  total = 0;
  limit = 500;
  paginacaoList: any;
  paginacao: any;
  lista: any;
  displayedItems = [];
  range = 5;
  indexInicial: number;
  indexRange: number;
  indexLimit: any;
  pageArray = [];

  constructor(
    private loading: NgxSpinnerService,
    private imunizacaoService: ImunizacaoService
  ) {}

  async ngOnInit() {
    this.paginacaoList = ['5', '10', '20', '30', '40', '50'];
    this.lista = this.filesLogs;
    this.indexLimit = this.lista.length;
    this.updateDisplayedItems();
    this.pageLimit();
  }

  updateDisplayedItems() {
    if (this.currentPage > this.limit) {
      this.currentPage = this.limit;
    }

    this.indexInicial = Number(this.currentPage) * Number(this.range) - Number(this.range) + 1;
    this.indexRange = Number(this.currentPage) * Number(this.range);

    if (this.indexRange > this.indexLimit) {
      this.indexRange = this.indexLimit;
    }
    this.pageLimit();

    let startIndex = (Number(this.currentPage) - 1) * this.range;
    this.displayedItems = this.lista.slice(Number(startIndex), Number(startIndex) + Number(this.range));
  }

  onRangeChange(newRange: number) {
    this.range = newRange;
    this.pageLimit();
    this.updateDisplayedItems();
  }

  avancaPagina() {
    if (this.currentPage < this.limit) {
      this.currentPage += 1;
      if (this.currentPage == this.limit) {
        this.indexRange = this.limit;
      }
      this.updateDisplayedItems();
    }
  }

  voltaPagina() {
    if (this.currentPage > 1) {
      this.currentPage -= 1;
      this.updateDisplayedItems();
    }
  }

  pageSelect(pagina) {
    this.currentPage = pagina;
    this.updateDisplayedItems();
  }

  pageLimit() {
    this.pageArray = [];
    this.limit = Math.ceil(this.lista.length / this.range);
    for (let index = 0; index < this.limit; index++) {
      this.pageArray.push(index + 1);
    }
  }

  fechar(data?) {
    this.fecharModal.emit();
  }

  getDate(date) {
    return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
  }

  getIp(ip) {
    console.log(ip);
    const array = ip.split(',');
    return array[0];
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-arquivos-logs/modal-arquivos-logs.component.ts